module.exports = __webpack_public_path__ + "static/sertifika-izmir-enternasyonal-fuari-1940-1-444f78e3ca8b78d0b54ae0c24aa07eac.jpg";